import CellField from '../blocks/calendar/CellField'
import { AbstractCellFieldController, AbstractOccupiableCellFieldController, setCellFieldControllerSymbols, setOccupiableCellFieldControllerSymbols } from '../generated'

export default AbstractCellFieldController

/** @constructor @extends {AbstractOccupiableCellFieldController} @suppress {checkTypes} */ function _OccupiableCellFieldController() {}
AbstractOccupiableCellFieldController.__implement(
 _OccupiableCellFieldController.prototype = /** @type {!AbstractOccupiableCellFieldController} */ ({
  __$constructor() {
   setOccupiableCellFieldControllerSymbols(this,{
    _occupied: new Set(),
   })
  },
  drawOccupied() {
   const{
    asICellFieldController:{cellField},
    asIOccupiableCellFieldController:{occupied},
   }=this
   for(let oc of occupied){
    cellField.occupyCell(oc)
   }
  },
  clearOccupied() {
   const{
    asICellFieldController:{cellField},
    asIOccupiableCellFieldController:{occupied},
   }=this
   for(let oc of occupied){
    cellField.unoccupyCell(oc)
   }
   occupied.clear()
  },
  occupy(cells) { // need to store occupied in a set
   const{asIOccupiableCellFieldController:{occupied}}=this
   for (const cell of cells) {
    occupied.add(cell)
   }
  },
 }),
)

/** @constructor @extends {AbstractCellFieldController} @suppress {checkTypes} */ function _CellFieldController() {}
AbstractCellFieldController.__implement(
 AbstractOccupiableCellFieldController,
 _CellFieldController.prototype = /** @type {!AbstractCellFieldController} */ ({
  __$constructor() {
   const cellField = new CellField()
   const projected = new Set()
   setCellFieldControllerSymbols(this, {
    _projected: projected,
    _cellField: cellField,
   })
  },
  project(endCell,startCell) {
   const {
    state:{start:s},
    asICellFieldController:{projected,drawProjected,setState},
   } = this
   const start = startCell !== undefined ? startCell : s
   if(start < endCell) {
    setState({projectStart:start, projectEnd:endCell})

    for (let i=start+1;i<=endCell;i++) {
     projected.add(i)
    }
   }
   drawProjected()
  },
  drawProjected() {
   const{
    asICellFieldController:{projected,projectStart,projectEnd},
    cellField:{asICellField:{projectCell,projectStartCell,projectEndCell}},
   }=this
   for (const d of projected) {
    projectCell(d)
   }
   projectStartCell(projectStart)
   projectEndCell(projectEnd)
  },
  clearProjectedEnds() {
   const{
    asICellFieldController:{projectStart,projectEnd,setState},
    cellField:{asICellField:{unprojectEndCell,unprojectStartCell}},
   }=this
   setState({projectStart:null,projectEnd:null})
   unprojectEndCell(projectEnd)
   unprojectStartCell(projectStart)
  },
  clearProjected() {
   const{
    asICellFieldController:{projected,clearProjectedEnds},
    cellField:{asICellField:{unprojectCell}},
   }=this
   for (const d of projected) {
    unprojectCell(d)
   }
   projected.clear()
   clearProjectedEnds()
  },
  cancel() {
   const{superCellFieldController:{cancelStart,cancelEnd,clearProjected}}=this
   cancelEnd()
   cancelStart()
   clearProjected()
  },
  cancelStart() {
   const{
    asICellFieldController:{
     cellField,
     asIStateful:{setState,state:{start}},
    },
   }=this
   if (!start) return
   setState({ start: null, uiState: 'selectingStart' })
   cellField.unstartCell(start)
  },
  cancelEnd() {
   const{asIStateful:{setState},cellField:{asICellField:{unendCell}},state:{end}}=this
   if (!end) return
   setState({end:null,uiState:'selectingEnd'})
   unendCell(end)
  },
  selectStart(start) {
   const{
    asIStateful:{setState},cellField:{asICellField:{startCell}},
   }=this

   setState({start,uiState:'selectingEnd'})
   startCell(start)
  },
  selectEnd(end) {
   const{
    superCellFieldController:{cancelEnd},
    asICellFieldController:{project,clearProjected},
    asIStateful:{setState},cellField:{asICellField:{endCell}},
    state:{end:stateEnd},
   }=this
   if (stateEnd) {
    cancelEnd()
    clearProjected()
   }
   setState({end,uiState:'selected'})
   endCell(end)
   project(end)
  },
  setupCellsClasses(cells) {
   // const{cellField:{state}}=this
   // for (const cell of cells) {
   //   const{props:{number:DATE}}=cell

   //   /** @noinline */
   //   const D = `d${DATE}`
   //   const classesInfo = Object.defineProperties({}, /** @type {!ru.hulkmoto.ICellFieldController.Classes} */ ({
   //     // CellSelected: {
   //     //   enumerable: true,
   //     //   get() {
   //     //     /** @type {ru.hulkmoto.Cell} */
   //     //     const d = state[D]
   //     //     const { start, end } = d
   //     //     if (start || end) return true
   //     //     return false
   //     //   },
   //     // },
   //     // CellOccupied: {
   //     //   enumerable: true,
   //     //   get() {
   //     //     /** @type {ru.hulkmoto.Cell} */
   //     //     const d = state[D]
   //     //     const { occupy } = d
   //     //     if (occupy) {
   //     //       return true
   //     //     }
   //     //     return false
   //     //   },
   //     // },
   //     // CellProjected: {
   //     //   enumerable: true,
   //     //   get() {
   //     //     /** @type {ru.hulkmoto.Cell} */
   //     //     const d = state[D]
   //     //     const { projected } = d
   //     //     if (projected) {
   //     //       return true
   //     //     }
   //     //     return false
   //     //   },
   //     // },
   //   }))
   //   setupClassSeers(/** @type {!HTMLElement} */ (cell), classesInfo, this) // what about clearing class seers
   //   // setTimeout(() => , 1) // why to?
   // }
  },
 }),
)
